<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="应急" name="emergent" style="height: 100%;">
				<emergent-index />
			</el-tab-pane>
			<el-tab-pane label="备货" name="stockup" style="height: 100%;">
				<stockup-index />
			</el-tab-pane>	
			<el-tab-pane label="自定义" name="custom" style="height: 100%;">
				<custom-index />
			</el-tab-pane>		
		</el-tabs>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import emergentIndex from './list/emergent.vue'
	import stockupIndex from './list/stockup.vue'
	import customIndex from './list/custom.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: 'emergent'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			emergentIndex,
			stockupIndex,
			customIndex
		}
	}
</script>